import { render } from "./AdminHomeSettings.vue?vue&type=template&id=5cb92166&scoped=true"
import script from "./AdminHomeSettings.vue?vue&type=script&lang=js"
export * from "./AdminHomeSettings.vue?vue&type=script&lang=js"

import "./AdminHomeSettings.vue?vue&type=style&index=0&id=5cb92166&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb92166"]])

export default __exports__